<template>
  <div v-if="false" class="w-full min-h-screen flex items-center justify-center">
    <div class="bg-up-bg border-l-4 border-brand px-10 black p-4" role="alert">
        <p class="font-bold">Maintenance</p>
        <p>Our website is currently undergoing maintenance to improve your experience.</p>
      </div>
  </div>
  <div v-else class="h-full w-full">
    <router-view></router-view>
  </div>
</template>

<script>

// import ScanPage from './pages/Scan.vue'
// import LoginPage from './pages/Login.vue'

export default {
  name: 'App',
  components: {
    // ScanPage,
    // LoginPage
  }
 
}
</script>

<style>

</style>
